<template>
  <filter-button
    :count-filtered="countFiltered"
    :disabled-clear="!isClearFilter"
    :disabled-apply="!isChangeFilter"
    @cancel="handleCancelFilter"
    @clear="handleClearFilter"
    @apply="handleSearchFilter"
  >
    <template v-slot:content>
      <v-list-item class="ml-5 mr-5 fixWidth d-block">
        <v-multiple-selected
          t-data="selector-filter"
          title="Branch"
          placeholder="All Branches"
          :branch="orgList.all"
          :selectedBranch="orgList.selected"
          :syncData="syncListSelectedData"
          :rule="() => true"
          :multiple="true"
          :is-changed="isChanged"
          :is-disabled="hasOneOrg"
          @resetIsChanged="isChanged = false"
        ></v-multiple-selected>
      </v-list-item>

      <v-list-item class="mt-2 ml-5 mr-5 fixWidth d-block">
        <p
          class="filterContentTitle sub-body-bold mb-0"
          t-data="department-title"
        >
          Department
        </p>
        <v-select
          class="can-disable-selector selector-filter"
          t-data="department-selector"
          placeholder="Select Department"
          :items="departmentList"
          outlined
          required
          color="primary500Color"
          dense
          v-model="departmentSelected"
          item-text="name"
          item-value="id"
          :disabled="departmentList.length <= 0"
        ></v-select>
      </v-list-item>

      <v-list-item
        class="mt-2 ml-5 mr-5 fixWidth d-block"
        t-data="order-channel-filter"
      >
        <p class="mb-0 filterContentTitle sub-body-bold">Channel</p>
        <v-select
          class="selector-filter"
          t-data="channel-selector"
          placeholder="Any Channel"
          :items="channelList"
          outlined
          required
          color="primary500Color"
          dense
          v-model="channelSelected"
          item-text="label"
          item-value="value"
        ></v-select>
      </v-list-item>

      <v-list-item
        class="mt-2 ml-5 mr-5 fixWidth d-block"
        t-data="order-channel-filter"
      >
        <p class="mb-0 filterContentTitle sub-body-bold">Status</p>
        <v-select
          class="selector-filter"
          t-data="channel-selector"
          placeholder="All status"
          :items="statusList"
          outlined
          required
          color="primary500Color"
          dense
          v-model="statusSelected"
          item-text="label"
          item-value="value"
        ></v-select>
      </v-list-item>

      <v-list-item
        class="mt-2 ml-5 mr-5 fixWidth d-block"
        t-data="order-channel-filter"
      >
        <p class="mb-0 filterContentTitle sub-body-bold">For package</p>
        <v-select
          class="selector-filter"
          t-data="channel-selector"
          placeholder="All"
          :items="forPackageList"
          outlined
          required
          color="primary500Color"
          dense
          v-model="forPackageSelected"
          item-text="label"
          item-value="value"
        ></v-select>
      </v-list-item>
    </template>
  </filter-button>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import MultipleSelected from '../../components/MultipleSelected.vue'
import FilterButton from '../../components/FilterButton'
import {convertSelectedData} from '@/helper/helper'
import {displayTypeText, forPackageText, statusTextOption} from '@/constants/appointment'
var _ = require('lodash')

export default {
  name: 'FilterDropdown',
  data: () => ({
    channelSelected: null,
    appliedChannel: null,
    promotionItems: [{text: 'Discount Package', value: '1'}],
    statusSelected: null,
    forPackageSelected: null,
    departmentSelected: null,
    countFiltered: 0,
    isChanged: false,
    appliedBranches: [],
    appliedPromotions: [],
    appliedDepartments: null,
    appliedStatus: null,
    appliedForPackage: null,
  }),
  components: {
    FilterButton,
    'v-multiple-selected': MultipleSelected
  },
  computed: {
    categoryItems() {
      return this.$store.state.news.category
    },
    isClearFilter() {
      const changedChannel = !_.isEqual(this.channelSelected, null)
      const changedStatus = !_.isEqual(this.statusSelected, null)
      const changedForPackage = !_.isEqual(this.forPackageSelected, null)
      const changedDepartment = !_.isEqual(this.departmentSelected, null)
      const changedBranch = !_.isEqual(this.orgList.selected, [])
      if (this.hasOneOrg) return changedChannel || changedDepartment || changedStatus || changedForPackage
      return changedChannel || changedDepartment || changedBranch || changedStatus || changedForPackage
    },
    isChangeFilter() {
      const changedChannel = !_.isEqual(
        this.channelSelected,
        this.appliedChannel
      )

      const changedDepartment = !_.isEqual(
        this.departmentSelected,
        this.appliedDepartments
      )
      const changedBranch = !_.isEqual(
        this.orgList.selected,
        this.appliedBranches
      )
      const changedStatus = !_.isEqual(
        this.statusSelected,
        this.appliedStatus
      )
      const changedForPackage = !_.isEqual(
        this.forPackageSelected,
        this.appliedForPackage
      )
      if (this.hasOneOrg) return changedChannel || changedDepartment || changedStatus || changedForPackage
      return changedChannel || changedDepartment || changedBranch || changedStatus || changedForPackage
    },
    hasOneOrg() {
      return this.orgList.all.length === 1
    },
    channelList() {
      const types = [{label: 'Any Channel', value: ''}]
      for (let key in displayTypeText) {
        if (displayTypeText.hasOwnProperty(key)) {
          types.push({label: displayTypeText[key], value: key})
        }
      }
      return types
    },
    statusList() {
      const types = [{label: 'All Status', value: ''}]
      for (let key in statusTextOption) {
        if (statusTextOption.hasOwnProperty(key)) {
          types.push({label: statusTextOption[key], value: key})
        }
      }
      return types
    },
    forPackageList() {
      const types = [{label: 'All', value: ''}]
      for (let key in forPackageText) {
        if (forPackageText.hasOwnProperty(key)) {
          types.push({label: forPackageText[key], value: key})
        }
      }
      return types
    },
    ...mapState('appointment', ['orgList', 'departmentList'])
  },
  watch: {
    departmentList() {
      if (this.departmentList.length === 0) {
        this.clearDepartmentSelected()
      }
    }
  },
  methods: {
    clearDepartmentSelected() {
      this.departmentSelected = null
    },
    sumFiltered() {
      const sumChannel = this.channelSelected === null ? 0 : 1
      const sumBranch =
        this.hasOneOrg || this.orgList.selected.length <= 0 ? 0 : 1
      const sumDepartment = this.departmentSelected === null ? 0 : 1
      const sumStatus = this.statusSelected === null ? 0 : 1
      const sumForPackage = this.forPackageSelected === null ? 0 : 1
      return sumBranch + sumDepartment + sumChannel + sumStatus + sumForPackage
    },
    syncListSelectedData(data) {
      const allBranch = data !== null && data.length === 0
      this.clearDepartmentSelected()
      this.resetDepartmentList()
      this.orgList.selected = []
      this.orgList.selected = convertSelectedData(
        data,
        this.orgList.all,
        this.orgList.selected
      )
      if (!allBranch) {
        this.fetchDepartment(data)
      }
    },
    handleSearchFilter() {
      this.$emit('apply')
      this.appliedChannel = this.channelSelected
      this.appliedStatus = this.statusSelected
      this.appliedForPackage = this.forPackageSelected
      this.appliedBranches = this.orgList.selected
      this.appliedDepartments = this.departmentSelected
      this.setFilterChannel(this.channelSelected)
      this.setFilterDepartment(this.departmentSelected)
      this.setFilterStatus(this.statusSelected)
      this.setFilterForPackage(this.forPackageSelected)
      this.fetch()
      this.countFiltered = this.sumFiltered()
    },
    handleClearFilter() {
      if (!this.hasOneOrg) this.orgList.selected = []
      this.channelSelected = null
      this.statusSelected = null
      this.forPackageSelected = null
      this.departmentSelected = null
      this.isChanged = true
    },
    handleCancelFilter() {
      if (!this.hasOneOrg) {
        this.orgList.selected = this.appliedBranches
        this.isChanged = true
      }
      // wait for multiple select render
      this.$nextTick(() => {
        this.channelSelected = this.appliedChannel
        this.statusSelected = this.appliedStatus
        this.forPackageSelected = this.appliedForPackage
        this.departmentSelected = this.appliedDepartments
        this.setFilterChannel(this.channelSelected)
        this.setFilterDepartment(this.departmentSelected)
        this.countFiltered = this.sumFiltered()
      })
    },
    ...mapActions('appointment', [
      'fetchDepartment',
      'fetch',
      'setFilterDepartment',
      'setFilterChannel',
      'setFilterStatus',
      'setFilterForPackage',
      'resetDepartmentList'
    ])
  }
}
</script>
<style scoped>
::v-deep .v-list-item__title{
  font-size: 16px !important;
}
</style>
